import { render, staticRenderFns } from "./dap-wizard-methodology-simple.page.vue?vue&type=template&id=04876b7d&scoped=true"
import script from "./dap-wizard-methodology-simple.page.vue?vue&type=script&lang=ts"
export * from "./dap-wizard-methodology-simple.page.vue?vue&type=script&lang=ts"
import style0 from "./dap-wizard-methodology-simple.page.vue?vue&type=style&index=0&id=04876b7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04876b7d",
  null
  
)

export default component.exports